const { NODE_ENV } = process.env
const { hostname } = window.location

const servers = {
  local: "http://localhost:5031",
  customDev: "https://react.customdev.solutions:5031",
  live: "https://predivauth.com:5031"
}

var URL;
if (NODE_ENV === "production" && hostname === "react.customdev.solutions") URL = servers.customDev
else if (NODE_ENV === "production" && hostname === "predivauth.com") URL = servers.live
else URL = servers.local

export const connection_string = `${URL}/api/v1`
export const image_url = `${URL}/`

// export let connection_string;
// export let image_url;
// export let vendor_register;
// export let vendor_login;

// if (window.location.hostname == "localhost") {
//   connection_string = "http://localhost:5030/api/v1";
//   image_url = "http://localhost:5030/";
//   vendor_register = "https://surihatev.com/surihatev/surihatevendor/register";
//   vendor_login = "https://surihatev.com/surihatev/surihatevendor";
// }else {
  // connection_string = URL + "/api/v1";
  // image_url = URL + "/";
  // vendor_register = "https://surihatev.com/surihatev/surihatevendor/register";
  // vendor_login = "https://surihatev.com/surihatev/surihatevendor";
// }
